import { Screen } from './api/types';

class SyosScreenButton {
  $el?: HTMLButtonElement;

  screen: Screen;

  onClick?: () => void;

  constructor($el: HTMLButtonElement, screen: Screen, onClick: { (): void }) {
    this.$el = $el;
    this.screen = screen;

    this.onClick = onClick;

    this.$el.addEventListener('click', onClick);
  }

  focus() {
    this.$el?.focus();
  }

  disable() {
    if (this.screen?.isAvailable) {
      this.$el?.classList.add('disabled');
      this.$el?.setAttribute('aria-disabled', 'true');
    }
  }

  enable() {
    if (this.screen.isAvailable) {
      this.$el?.classList.remove('disabled');
      this.$el?.removeAttribute('aria-disabled');
    }
  }

  destroy() {
    this.$el?.removeEventListener('click', this.onClick!);

    this.$el = undefined;

    this.onClick = undefined;
  }
}

export default SyosScreenButton;
